/* The client's gallery, as the manager needs it.
 *
 * A client has exactly one and is never shown it — they work in albums. The id
 * is still needed to READ (the album list and its ordering hang off the gallery
 * row); it is not needed to write, because the server resolves it. That
 * asymmetry is deliberate: an id that only reads can be empty on a client who
 * has no gallery yet without anything breaking, which is what an empty id used
 * to do.
 */
import { useQuery } from '@tanstack/react-query';
import { getGalleries } from '@/data/client';

export function useGalleries() {
  const { data, isFetching } = useQuery({
    queryKey: ['galleries'], queryFn: getGalleries, staleTime: 60_000,
  });
  const galleries = data?.galleries ?? [];
  return {
    /** '' until the client's first album creates the gallery. */
    galleryId: data?.primaryGalleryId || galleries[0]?.id || '',
    /* Rides along with this read rather than polling: every gallery mutation
       invalidates ['galleries'], so the save bar is refreshed by the same
       invalidation that refreshes the albums. */
    featuredUsed: data?.featuredUsed ?? 0,
    featuredLimit: data?.featuredLimit ?? 6,
    pending: !!data?.pending,
    pendingSince: data?.pendingSince || '',
    publishedAt: data?.publishedAt || '',
    loading: isFetching && !data,
  };
}
